exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bar-chart[data-v-299b89b0]{width:100%;height:100%}.bar-chart .chart[data-v-299b89b0]{width:100%;height:100%}\n", ""]);

// exports
